import React from 'react';
import { Helmet } from 'react-helmet-async';
import Herosection from './Herosection';
import Aboutsec2 from './Aboutsec2';
import OurValues from './OurValues';
import TrandingTechnologies from './TrandingTechnologies';
import ServicesAndProject from './ServicesAndProject';
import HiringSection from './HiringSection';
import ConnectMessage from '../../Component/ConnectMessage';
import InfoSection from './InfoSection';
const AboutUs = () => {
    return (
        <div>
            <Helmet>
              <title>About Us - BastionEx | AI, Blockchain & Digital Solutions Experts</title>
              <meta name="description" content="Learn about BastionEx, a trusted blockchain, AI, web and mobile app development company with 15+ years of experience delivering innovative digital solutions worldwide." />
              <link rel="canonical" href="https://bastionex.net/aboutus" />
            </Helmet>
            <Herosection />
            <Aboutsec2 />
            <OurValues />
           {/* <TrandingTechnologies /> */}
            <ServicesAndProject />
            {/* <InfoSection/ > */}
            <HiringSection />
            <ConnectMessage />  
        </div>
    );
};

export default AboutUs;

